import React from "react";
import PropTypes from "prop-types";
import { defaultTemplate } from "core/hoc";
import {
    BaasicButton,
    BaasicTable,
    TableFilter,
    EmptyState,
    QueryDropdown
} from "core/components";
import { isSome } from "core/utils";
import { ApplicationListLayout, Content } from "core/layouts";

const TrackingCaseListTemplate = function({ trackingCaseListViewStore }) {
    const { 
        tableStore, 
        routes, 
        queryUtility, 
        authorization,
        facilityStore,
        localPatientStore,
        itemCategoryStore,
        caseStatusStore
     } = trackingCaseListViewStore;

    return (
        <ApplicationListLayout
            store={trackingCaseListViewStore}
            authorization={authorization}
        >
            <Content emptyRenderer={renderEmpty(routes)}>
                <div className="u-mar--bottom--sml">
                    <TableFilter queryUtility={queryUtility} showSearchFilter={false} filterVisible={true}>
                        <div className="col col-sml-12 col-med-6 col-lrg-4 col-xxlrg-2 form__group">
                            <QueryDropdown queryUtility={queryUtility} store={facilityStore} propertyName="facilityId" label="Facility" />
                        </div>
                        <div className="col col-sml-12 col-med-6 col-lrg-4 col-xxlrg-2 form__group">
                            <QueryDropdown queryUtility={queryUtility} store={localPatientStore} propertyName="patientId" label="Patient" />
                        </div>
                        <div className="col col-sml-12 col-med-6 col-lrg-4 col-xxlrg-2 form__group">
                            <QueryDropdown queryUtility={queryUtility} store={itemCategoryStore} propertyName="itemCategoryId" label="Item Category" />
                        </div>
                        <div className="col col-sml-12 col-med-6 col-lrg-4 col-xxlrg-2 form__group">
                            <QueryDropdown queryUtility={queryUtility} store={caseStatusStore} propertyName="caseStatusId" label="Status" />
                        </div>
                    </TableFilter>
                </div>
                <div className="card--table">
                    <BaasicTable
                        authorization={authorization}
                        tableStore={tableStore}
                        actionsComponent={renderActions}
                    />
                </div>
            </Content>
        </ApplicationListLayout>
    );
};

function renderEmpty(routes) {
    return (
        <EmptyState
            title="TRACKING_CASE.LIST.EMPTY_STATE.TITLE"
            actionLabel="TRACKING_CASE.LIST.EMPTY_STATE.ACTION"
            callToAction={routes.create}
        />
    );
}

TrackingCaseListTemplate.propTypes = {
    trackingCaseListViewStore: PropTypes.object.isRequired
};

function renderActions({ item, actions, authorization }) {
    if (!isSome(actions)) return null;

    const { onEdit,onPreview, onDelete, onDocuments, onCopy, onNotes } = actions;
    if (!isSome(onEdit) && !isSome(onPreview) && !isSome(onDelete) && !isSome(onDocuments) && !isSome(onCopy) && !isSome(onNotes)) return null;

    return (
        <td className="table__body--data right">
            <div className="table__icons">
                {isSome(onPreview) ? (
                    <BaasicButton
                        authorization={authorization ? authorization.update : null}
                        className="btn btn--icon"
                        label='Preview'
                        icon='u-icon u-icon--preview u-icon--sml'
                        onlyIcon={true}
                        onClick={() => onPreview(item)}>
                    </BaasicButton>
                ) : null}
                {isSome(onCopy) ? (
                    <BaasicButton
                        authorization={authorization ? authorization.update : null}
                        className="btn btn--icon"
                        label='Copy'
                        icon='u-icon u-icon--copy u-icon--sml'
                        onlyIcon={true}
                        onClick={() => onCopy(item)}>
                    </BaasicButton>
                ) : null}
                {isSome(onDocuments) ? (
                    <BaasicButton
                        authorization={authorization ? authorization.update : null}
                        className="btn btn--icon"
                        label='Documents'
                        icon='u-icon u-icon--document u-icon--sml'
                        onlyIcon={true}
                        onClick={() => onDocuments(item)}>
                    </BaasicButton>
                ) : null} 
                {/* {isSome(onNotes) ? (
                    <BaasicButton
                        authorization={authorization ? authorization.update : null}
                        className="btn btn--icon"
                        label='Notes'
                        onClick={() => onNotes(item)}>
                    </BaasicButton>
                ) : null} */}
                {isSome(onEdit) ? (
                    <BaasicButton
                        authorization={authorization ? authorization.update : null}
                        className="btn btn--icon"
                        label='Edit'
                        icon='u-icon u-icon--edit u-icon--sml'
                        onlyIcon={true}
                        onClick={() => onEdit(item)}>
                    </BaasicButton>
                ) : null}
                {isSome(onDelete) ? (
                    <BaasicButton
                        authorization={authorization ? authorization.update : null}
                        className="btn btn--icon is-delete"
                        label='Delete'
                        icon='u-icon u-icon--delete u-icon--sml'
                        onlyIcon={true}
                        onClick={() => onDelete(item)}>
                    </BaasicButton>
                ) : null}
            </div>
        </td>
    );
}

renderActions.propTypes = {
    item: PropTypes.object,
    actions: PropTypes.object,
    authorization: PropTypes.any
};

export default defaultTemplate(TrackingCaseListTemplate);